"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupInput = exports.InputContainer = exports.SelectContainer = exports.TextArea = exports.Input = exports.Container = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const styles_1 = require("../../styles");
const Flex_1 = tslib_1.__importDefault(require("../Elements/Flex"));
exports.Container = (0, styled_components_1.default)(Flex_1.default) `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
exports.Input = (0, styled_components_1.default)('input') `
  outline: none;
  display: block;
  background: transparent;
  width: 100%;
  line-height: 1.5;
  border: none;
  color: ${props => (props.disabled ? styles_1.Colors.Border : 'inherit')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'auto')};
`;
exports.TextArea = (0, styled_components_1.default)('textarea') `
  min-width: 100%;
  max-width: 100%;
  min-height: 6rem;
  outline: none;
  display: block;
  width: 100%;
  line-height: 1.5;
  border: none;
  color: inherit;
  background: transparent;
  color: ${props => (props.disabled ? styles_1.Colors.Border : 'inherit')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'auto')};
`;
exports.SelectContainer = (0, styled_components_1.default)(Flex_1.default) `
  width: 100%;
  color: ${styles_1.Colors.Dark};
`;
exports.InputContainer = (0, styled_components_1.default)(Flex_1.default) `
  width: 100%;
  color: ${styles_1.Colors.Dark};
  border: 1px solid ${styles_1.Colors.Border};
  border-radius: 3px;
  position: relative;
  background: ${styles_1.Colors.InputBackground};
  transition: background 0.2s ease-in-out;
  &:after {
    position: absolute;
    bottom: -1px;
    border-radius: 0 0 3px 3px;
    left: 0;
    width: 100%;
    height: 3px;
    content: '';
    opacity: ${props => (props.error ? 1 : 0)};
    transition: opacity 0.2s ease-in-out;
    background: ${props => (props.error ? styles_1.Colors.Danger : styles_1.Colors.Primary)};
  }
  &:focus-within {
    background: ${styles_1.Colors.White};
    &:after {
      opacity: 1;
      z-index: 10;
    }
  }
  & > * {
    ${StyledFunctions_1.elementSize};
  }
  & > *:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  & > *:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
exports.GroupInput = (0, styled_components_1.default)(Flex_1.default) `
  justify-content: space-between;
  & > * {
    flex: 1;
    margin-right: 1rem;
  }
  & > *:last-child {
    margin-right: 0;
  }
`;
